var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"info","dark":"","small":"","absolute":"","left":"","fab":"","elevation":"0","width":"50px","height":"50px"},on:{"click":function($event){return _vm.$emit('click:button')}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }